/* GA — default the pill-style Size picker to "Medium" instead of
   whichever value Shopify picks first (the first available variant,
   i.e. usually "Small"), without touching variant order in Admin.
   Skips this when the URL already names a specific variant (a shared
   product link, or coming back from a re-render) so we never fight an
   explicit selection. */
document.addEventListener('DOMContentLoaded', function () {
  if (new URLSearchParams(window.location.search).has('variant')) return;

  document.querySelectorAll('.product-form__input--pill').forEach(function (fieldset) {
    var current = fieldset.querySelector('input[type="radio"]:checked');
    if (!current || current.value.trim().toLowerCase() !== 'small') return;

    var medium = fieldset.querySelector('input[type="radio"][value="Medium" i]');
    if (!medium || medium.classList.contains('disabled') || medium.disabled) return;

    medium.checked = true;
    medium.dispatchEvent(new Event('change', { bubbles: true }));
  });
});
